import React from "react";
import Header from '../../component/Header/Header'
import Footer from '../../component/Footer/Footer.js';
import { RisingStar } from "component/RisingStar";
import BlockHeader from "component/BlockHeader/BlockHeader";
import Breadcrumb from "component/Breadcrumb";
import { PageCredential } from "component/PageCredential";

const PageRisingStar = () => {
    return (
        <>
            <Header/>
            <PageCredential title={"Rising Star"}/>
                <div className="container">
                    <Breadcrumb
                        items={[
                            ['/', 'Crowdbees']
                            ,['Rising Stars']
                        ]}
                    />
                    <BlockHeader 
                        title="Rising Stars" 
                        desc="Top 20 Users with the best ratings"
                    />
                        
                    <RisingStar listArgs={{
                        posts_per_page : 20
                    }}/>
                </div>
            <Footer/>
        </>
    )
}

export default PageRisingStar;